import React from 'react';
import  {IndexLink,Link} from 'react-router';

export default class Splash_Signup extends React.Component{
	constructor(props) {
    super(props);
	
  }
  
  render() {
    return (
    	<div id="expert_splash">
			<h1>
				<img  src="static/img/homeimg/splash-expert-logo.png" alt="Versity" />
			</h1>
			<div className="expert_g1">
				<div className="container">
					<h2>
						Get Discovered By Employers
					</h2>
					<p className="txt">
						Get found by employers who like you for more than your work experience.
					</p>
					<p className="btn">
						<Link to="/signup">
							 SIGN UP
						</Link>
					</p>
					<p className="srolldown">
						<img  src="static/img/homeimg/down.gif" alt="Scroll Down" />
					</p>
				</div>
			</div>
			<div className="expert_g2">
				<div className="container">
					<h2>
						Get Recognized By The Best
					</h2>
					<div className="expert_newgroup01">
						<div className="subgroup">
							<img  src="static/img/homeimg/expert-icon01.png" alt="" />
							<h3>
								Multiple Job Types
							</h3>
							<p>
								Earn on your own schedule
							</p>
						</div>
						<div className="subgroup">
							<img  src="static/img/homeimg/expert-icon02.png" alt="" />
							<h3>
								Explore jobs from top employers
							</h3>
							<p>
								Get real information about jobs and companies
							</p>
						</div>
						<div className="subgroup">
							<img  src="static/img/homeimg/expert-icon03.png" alt="" />
							<h3>
								Paid Jobs and Internships
							</h3>
							<p>
								Earn almost double the wage of your average campus job by helping someone out
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className="expert_g3">
				<p className="link">
					<a href="#">
						<img src="static/img/homeimg/expert-icon05.png" alt="" />
					</a>
				</p>
			</div>
			
		</div>

      
    )
  }
};



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/splash_expert.js
 **/